import FAQGroup from './FAQGroup.vue'

export { FAQGroup }
export default FAQGroup